// src/components/core/BackToHomeLink.jsx
// *******************************************************************************
// BACK TO HOME LINK COMPONENT
// *******************************************************************************
// Reusable component to display a centered link "Back to Home" that navigates
// to the dashboard/overview screen. Used in module Init pages to allow users
// to easily return to the home screen after accessing modules via Quick Access.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppstoreOutlined, HomeOutlined } from '@ant-design/icons';
import app from 'configs/appResolver';
import translateX from 'utils/translateX';
import useZustand from 'hooks/useZustand';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const BackToHomeLink = ({ style = {}, forceToHide }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const storedModule = useZustand('module', 'config');
  const storedCurrentPage = useZustand('module', 'currentPage');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const navigate = useNavigate();

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  if (typeof forceToHide === 'undefined') {
    forceToHide = storedModule?.initialPage === storedCurrentPage?.name;
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleClick = useCallback(
    e => {
      e.preventDefault();
      navigate(app.AUTHENTICATED_ENTRY);
    },
    [navigate]
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (forceToHide) return null;

  return (
    <div
      style={{
        marginTop: 24,
        // marginBottom: 48,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 13,
        ...style,
      }}
    >
      <a
        href={app.AUTHENTICATED_ENTRY}
        onClick={handleClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <HomeOutlined />
        {translateX('back_to_home')}
      </a>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default BackToHomeLink;
